// extracted by mini-css-extract-plugin
export default {"text-input":"TextInput_text-input__RYwrk","text-input--error":"TextInput_text-input--error__y8hJ8"};